// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import LocationSchema from './location-schema';
import ContactRequestSchema from './contact-request-schema';

const schema = {
  $id: '/company-request-schema',
  type: 'object',
  required: ['name', 'professionIds', 'zip', 'city', 'location'],
  properties: {
    name: {
      type: 'string',
      minLength: 1,
    },
    externalId: {
      type: 'string',
      format: 'uuid',
      nullable: true,
    },
    logoDocumentExternalId: {
      type: 'string',
      nullable: true,
    },
    description: {
      type: 'string',
      nullable: true,
    },
    website: {
      type: 'string',
      nullable: true,
    },
    employeesCount: {
      type: 'integer',
      nullable: true,
    },
    apprenticesCount: {
      type: 'integer',
      nullable: true,
    },
    apprenticeShipsCount: {
      type: 'integer',
      nullable: true,
    },
    professionIds: {
      type: 'array',
      items: {
        type: 'integer',
      },
    },
    street: {
      type: 'string',
      nullable: true,
    },
    houseNumber: {
      type: 'string',
      nullable: true,
    },
    zip: {
      type: 'string',
      minLength: 1,
    },
    city: {
      type: 'string',
      minLength: 1,
    },
    location: {
      ...LocationSchema,
    },
    contact: {
      ...ContactRequestSchema,
    },
    acceptConditions: {
      type: 'boolean',
    },
  },
} as IJSONSchema;

export default schema;
